import { render, staticRenderFns } from "./RetirementTargetInputs.vue?vue&type=template&id=de4b266a&"
import script from "./RetirementTargetInputs.vue?vue&type=script&lang=js&"
export * from "./RetirementTargetInputs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports